<ngx-spinner [name]="'consultar-fornecedor'" type="ball-clip-rotate-pulse" [fullScreen]="false"
    bdColor="rgba(0, 0, 0, 0.2)"></ngx-spinner>
<mat-card>
    <mat-card-header>
        <mat-card-title>Consultar Fornecedor</mat-card-title>
    </mat-card-header>
    <mat-divider></mat-divider>

    <mat-card-content *ngIf="!bConsulta">

        <div class="row">
            <div class="col-sm-6">
                <mat-form-field appearance="outline" [floatLabel]="'always'">
                    <mat-label>Filtro</mat-label>
                    <input matInput (keyup)="aplicarFiltroTabela($event)" placeholder="Filtro">
                </mat-form-field>
            </div>
        </div>

        <div class="row">
            <div class="col-sm">
                <table mat-table [dataSource]="fornecedoresSource" class="mat-elevation-z2" style="width: 100%;">

                    <ng-container matColumnDef="CNPJ">
                        <th mat-header-cell *matHeaderCellDef> CNPJ </th>
                        <td mat-cell *matCellDef="let element"> {{element.CNPJ}} </td>
                    </ng-container>

                    <ng-container matColumnDef="RazaoSocial">
                        <th mat-header-cell *matHeaderCellDef> Razão Social </th>
                        <td mat-cell *matCellDef="let element"> {{element.RazaoSocial}} </td>
                    </ng-container>

                    <ng-container matColumnDef="InscricaoEstadual">
                        <th mat-header-cell *matHeaderCellDef> Inscrição Estadual </th>
                        <td mat-cell *matCellDef="let element"> {{element.InscricaoEstadual}} </td>
                    </ng-container>

                    <ng-container matColumnDef="Cidade">
                        <th mat-header-cell *matHeaderCellDef> Cidade </th>
                        <td mat-cell *matCellDef="let element"> {{element.Cidade}} </td>
                    </ng-container>

                    <ng-container matColumnDef="UF">
                        <th mat-header-cell *matHeaderCellDef> UF </th>
                        <td mat-cell *matCellDef="let element"> {{element.UF}} </td>
                    </ng-container>


                    <ng-container matColumnDef="Consultar">
                        <th mat-header-cell *matHeaderCellDef> Consultar </th>
                        <td mat-cell *matCellDef="let element">
                            <button mat-icon-button matTooltip="Detalhar fornecedor" (click)="consultarFornecedor(element)"
                                class="iconbutton" color="primary">
                                <mat-icon aria-label="Expandir">search</mat-icon>
                            </button>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="consultarFornecedor(row)"></tr>

                    <!-- Row shown when there is no matching data that will be provided to the wrapper table. -->
                    <tr class="mat-row" *matNoDataRow>
                        <td class="mat-cell" colspan="6" style="text-align: center;">Não há fornecedores cadastrados no sistema ou com o filtro definido
                        </td>
                    </tr>
                </table>

                <mat-paginator [pageSizeOptions]="[10, 15, 20, 25]"></mat-paginator>
            </div>
        </div>
    </mat-card-content>

    <mat-card-content *ngIf="bConsulta">

        <!-- <div class="cadastro_header">
            Cadastrado dia: <strong>{{f.dataCadastro.value}}</strong>
        </div> -->

        <form [formGroup]="fornecedorForm">
            <div class="row">
                <div class="col-auto">
                    <div class="custom-checkbox custom-control">
                        <input type="checkbox" formControlName="status" id="remember" class="custom-control-input">
                        <label for="remember" class="custom-control-label">
                            <div style="margin-top: 3px;">Status</div>
                        </label>
                    </div>
                </div>

                <div class="col-sm text-right mr-2">
                    Cadastrado dia: <strong>{{f.dataCadastro.value}}</strong>
                </div>
            </div>

            <div class="row mt-4">
                <div class="col-auto">
                    <h1 class="customH1">Informações Gerais</h1>
                </div>
                <div class="col-sm">
                    <hr />
                </div>
            </div>

            <div class="borda">
                <div class="row">
                    <div class="col-sm">
                        <mat-form-field appearance="outline" [floatLabel]="'always'">
                            <mat-label>Razão Social</mat-label>
                            <input type="text" matInput formControlName="razaoSocial" required maxlength="100">
                            <mat-error *ngIf="f.razaoSocial.errors">
                                Campo obrigatório
                            </mat-error>
                        </mat-form-field>
                    </div>

                    <div class="col-sm">
                        <mat-form-field appearance="outline" [floatLabel]="'always'">
                            <mat-label>Nome Fantasia</mat-label>
                            <input type="text" matInput formControlName="nomeFantasia" required maxlength="100">
                            <mat-error *ngIf="f.nomeFantasia.errors">
                                Campo obrigatório
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>

                <div class="row">
                    <div class="col-sm">
                        <mat-form-field appearance="outline" [floatLabel]="'always'">
                            <mat-label>CNPJ</mat-label>
                            <input type="text" matInput formControlName="cnpj" required>
                            <mat-error *ngIf="f.cnpj.errors?.required">
                                Campo obrigatório
                            </mat-error>
                            <mat-error *ngIf="!f.cnpj.errors?.cnpjVerdadeiro">
                                CNPJ informado não é válido
                            </mat-error>
                        </mat-form-field>
                    </div>

                    <div class="col-sm">
                        <mat-form-field appearance="outline" [floatLabel]="'always'">
                            <mat-label>Inscrição Estadual</mat-label>
                            <input type="text" matInput formControlName="inscricaoEstadual" required maxlength="50">
                            <mat-hint align="end">Em caso de isenção, informar: "Isento"</mat-hint>
                            <mat-error *ngIf="f.inscricaoEstadual.errors">
                                Campo obrigatório
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>

                <div class="row">
                    <div class="col-auto">
                        <mat-form-field appearance="outline" [floatLabel]="'always'">
                            <mat-label>Telefone</mat-label>
                            <input type="text" matInput formControlName="telefone" [textMask]="{mask: maskTelefone}"
                                (ngModelChange)="onChangeTel($event, true)" required>
                                <mat-error *ngIf="f.telefone.errors?.required">
                                    Campo obrigatório
                                </mat-error>
                                <mat-error *ngIf="f.telefone.errors?.telefoneValido">
                                    Telefone inválido
                                </mat-error>
                        </mat-form-field>
                    </div>

                    <div class="col-auto">
                        <mat-form-field appearance="outline" [floatLabel]="'always'">
                            <mat-label>Telefone Secundário</mat-label>
                            <input type="text" matInput formControlName="telefoneSecundario"
                                [textMask]="{mask: maskTelefone2}" (ngModelChange)="onChangeTel($event, false)">
                        </mat-form-field>
                    </div>

                    <div class="col-sm">
                        <mat-form-field appearance="outline" [floatLabel]="'always'">
                            <mat-label>Responsável</mat-label>
                            <input type="text" matInput formControlName="responsavel" required maxlength="100">
                            <mat-error *ngIf="f.responsavel.errors">
                                Campo obrigatório
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>

                <div class="row">
                    <div class="col-sm">
                        <mat-form-field appearance="outline" [floatLabel]="'always'">
                            <mat-label>Observação</mat-label>
                            <input type="text" matInput formControlName="observacao" maxlength="100">
                            <mat-error *ngIf="f.observacao.errors">
                                Campo obrigatório
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>
            </div>


            <div class="row mt-4">
                <div class="col-auto">
                    <h1 class="customH1">Endereço</h1>
                </div>
                <div class="col-sm">
                    <hr />
                </div>
            </div>

            <div class="borda">
                <div class="row">
                    <div class="col-auto">
                        <mat-form-field appearance="outline" [floatLabel]="'always'" style="width: 150px;">
                            <mat-label>CEP</mat-label>
                            <input type="text" matInput formControlName="cep" required maxlength="10"
                                (ngModelChange)="buscarCEP()" [textMask]="{mask: maskCEP, guide:false}">
                            <mat-error *ngIf="f.cep.errors">
                                Campo obrigatório
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>

                <div class="row">
                    <div class="col-xs-auto col-md-8">
                        <mat-form-field appearance="outline" [floatLabel]="'always'">
                            <mat-label>Logradouro</mat-label>
                            <input type="text" matInput formControlName="logradouro" required maxlength="100">
                            <mat-error *ngIf="f.logradouro.errors">
                                Campo obrigatório
                            </mat-error>
                        </mat-form-field>
                    </div>

                    <div class="col-auto">
                        <mat-form-field appearance="outline" [floatLabel]="'always'">
                            <mat-label>Número</mat-label>
                            <input type="text" matInput formControlName="numero" required maxlength="20">
                            <mat-error *ngIf="f.numero.errors">
                                Campo obrigatório
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>

                <div class="row">
                    <div class="col-xs-auto col-md-3">
                        <mat-form-field appearance="outline" [floatLabel]="'always'">
                            <mat-label>Complemento</mat-label>
                            <input type="text" matInput formControlName="complemento" maxlength="100">
                            <mat-error *ngIf="f.complemento.errors">
                                Campo obrigatório
                            </mat-error>
                        </mat-form-field>
                    </div>

                    <div class="col-xs-auto col-md-4">
                        <mat-form-field appearance="outline" [floatLabel]="'always'">
                            <mat-label>Bairro</mat-label>
                            <input type="text" matInput formControlName="bairro" required maxlength="30">
                            <mat-error *ngIf="f.bairro.errors">
                                Campo obrigatório
                            </mat-error>
                        </mat-form-field>
                    </div>

                    <div class="col-xs-auto col-md-3">
                        <mat-form-field appearance="outline" [floatLabel]="'always'">
                            <mat-label>Cidade</mat-label>
                            <input type="text" matInput formControlName="cidade" required maxlength="30">
                            <mat-error *ngIf="f.cidade.errors">
                                Campo obrigatório
                            </mat-error>
                        </mat-form-field>
                    </div>

                    <div class="col-xs-auto col-md-2">
                        <mat-form-field appearance="outline" [floatLabel]="'always'" style="width: 100px;">
                            <mat-label>UF</mat-label>
                            <input type="text" matInput formControlName="uf" required maxlength="2">
                            <mat-error *ngIf="f.uf.errors">
                                Campo obrigatório
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>

                <div class="row">
                    <div class="col-sm">
                        <mat-form-field appearance="outline" [floatLabel]="'always'">
                            <mat-label>Referência</mat-label>
                            <input type="text" matInput formControlName="referencia" maxlength="180">
                            <mat-error *ngIf="f.referencia.errors">
                                Campo obrigatório
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>
            </div>

        </form>

        <div class="row mt-4">
            <div class="col-sm">
                <mat-divider></mat-divider>

                <section fxLayout fxLayoutAlign="space-between center" class="mtSection">
                    <button mat-flat-button color="warn" (click)="voltar()">
                        <mat-icon>arrow_back</mat-icon> Voltar
                    </button>
                    <button mat-flat-button color="primary" (click)="atualizar()">
                        <mat-icon>check</mat-icon> Atualizar Dados
                    </button>
                </section>
            </div>
        </div>
    </mat-card-content>
</mat-card>
